const resources = {
    searchResults: 'Search Results',
    sale: 'Sale'
};

module.exports = function getResource(label) {
    return resources[label];
};
